import React, {useEffect, useState} from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head} from '@inertiajs/inertia-react';
import "../../../sass/guest/add-address.scss";
import AddressValidationModal from "@/Pages/Organization/AddressValidationModal";
import AddressForm from "@/Pages/Organization/AddressForm";
import {useAddressForm, updateAddressFrom,  validationEffects}  from "@/Pages/Organization/AddressForm";
import styles from "../../../sass/components/Validation.module.scss";

export default function AddAddress() {
    const {data, setData, post, processing, errors} = useAddressForm();
    const [stateOptions, setStateOptions] = useState();
    const [validationModal, setValidationModal] = useState(false);
    const [validationObjects, setValidationObjects] = useState([]);
    const [validationOptions, setValidationOptions] = useState([]);
    const [save_address_value, setSaveAddress] = useState("0");

    useEffect(() => {
        axios.get(route('organization.add-address.states'))
            .then(res => setStateOptions(res.data));
    }, [])

    function updateAddressFromAutofill(autofillIndex) {
        let autofill = validationObjects[autofillIndex];
        updateAddressFrom(autofill, setData, setSaveAddress);
    }

    useEffect(() => {
        validationEffects(setValidationOptions, setValidationObjects, setValidationModal, errors);
    }, [errors])

    const hasDuplicates = (arr) => arr.length !== new Set(arr).size;

    const submit = (e) => {
        e.preventDefault();
        post(route('organization.add-address.store'));
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            {!hasDuplicates(validationOptions) &&
                <AddressValidationModal
                    validationModal={validationModal}
                    setValidationModal={setValidationModal}
                    validationOptions={validationOptions}
                    setAddress={updateAddressFromAutofill}
                />}
            <Head title={i18n.t("add-address.org-address")}/>
            <div className="outside-logo"></div>
            <div className="add-address">
                <form onSubmit={submit}>
                    <div className="title">{i18n.t("add-address.org-address")}</div>
                    {errors['duplicate_address'] &&
                        <div className={styles.validationErrors}>
                            <i className={styles.icon + " fas fa-times-circle"}></i>
                            <div className={styles.errors}>
                                <span className={styles.error}>{errors['duplicate_address']} </span>
                            </div>
                        </div>
                    }
                    {false && <ValidationErrors errors={errors}/>}
                    <AddressForm errors={errors} data={data} setData={setData} setSaveAddress={setSaveAddress}
                                 save_address_value={save_address_value} stateOptions={stateOptions}></AddressForm>
                    <div className="">
                        <Button className="w-100 btn btn-primary" processing={processing} dataTestid="add_address_form-button-continue">
                            <span>{i18n.t("add-address.continue")}</span><i className="far fa-chevron-right"></i>
                        </Button>
                    </div>
                </form>
            </div>
            <div className="step">
                <span>{i18n.t("add-address.step")} 1 {i18n.t("add-address.of")} 5</span>
            </div>
        </Authenticated>
    );
}

